import { react2panel } from 'common/util/react2panel';
import { FunnelsStepChartReact } from './index';
export const FunnelsStepChartEl = react2panel("mp-funnels-step-chart", FunnelsStepChartReact, {
  contexts: ["segmentFilterController"]
});